export const SET_MENU_OPEN = 'SET_MENU_OPEN';
export const SET_LAST_COHORT_INFO = 'SET_LAST_COHORT_INFO';
export const SET_EXTRA_PARTICIPANT_LIST = 'SET_EXTRA_PARTICIPANT_LIST';
